require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./facilitators-proposals-c-7-fx-cfeo-we-a-4-ea-e-uw-yq-a-uq-w.json") })
        }
      }, "path---facilitators-proposals-c-7-fx-cfeo-we-a-4-ea-e-uw-yq-a-uq-w");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---facilitators-proposals-c-7-fx-cfeo-we-a-4-ea-e-uw-yq-a-uq-w!./.cache/json/facilitators-proposals-c-7-fx-cfeo-we-a-4-ea-e-uw-yq-a-uq-w.json
// module id = 349
// module chunks = 231608221292675